<template>
  <header class="iv-header">
    <Row class-name="iv-main-width">
      <Col :span="16" class-name="iv-fs-24 iv-fc-85 iv-header-title iv-flex">
        <img src="@/assets/images/new-home/logo.png" style="height: 32px;"/>
      </Col>
      <Col :span="8" class-name="iv-text-right iv-header-right iv-flex">
        <Input v-model="value" placeholder="请输入关键字" class="iv-search">
          <Button slot="append" class="iv-header-search" type="search" @click="toSearch">搜索</Button>
        </Input>
      </Col>
    </Row>
  </header>
</template>

<script>
import Iconfont from '@/components/iconfont'

export default {
  data() {
    return {
      value: ''
    }
  },
  mounted() {
  },
  // directives: { clickoutside },
  computed: {},
  methods: {
    // ...mapMutations([
    //   'SKINLAYOUT',
    //   'ISNEWMESSAGE'
    // ])
    //面包屑跳转
    toNextPage(item) {
      if (this.currentRouteName === item.name) return
      this.$router.push({
        name: item.name,
        query: item.query
      })
    },
    onUserClick(name) {
    },
    //跳转首页
    toIndexPage() {
      this.$router.push('/index')
    },
    onOprateClick() {
      //this.getMessageList()
    },
    setIsNewMsg(type) {
      this.isNewMsg = type
    },
    toSearch() {
      this.$router.push({
        name: 'searchPage',
        query: {
          keyword: this.value
        }
      })
    }
  },
  components: {
    Iconfont
  }
}
</script>

<style lang="scss" scoped>
.ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
  border-radius: 0 4px 4px 0;
}

.iv-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9;
  background-color: #fff;
  // box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.09);
  .iv-header-title {
    height: 64px;
  }

  .iv-header-right {
    height: 64px;
    -webkit-box-pack: right;
    -webkit-justify-content: right;
    -ms-flex-pack: right;
    justify-content: right;

    .iv-search {
      /deep/ .ivu-input {
        width: 389px !important;
        height: 36px !important;
      }

      /deep/ .iv-header-search {
        height: 36px;
        width: 90px;
        padding-left: 10px !important;
        color: #fff !important;
        // background-color: #2d8cf0 !important;
        // border: 1px solid #2d8cf0 !important;
        .iconfont {
          font-size: 16px !important;
        }
      }
    }

  }

  .iv-flex {
    display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
    display: -moz-box; /* 老版本语法: Firefox (buggy) */
    display: -ms-flexbox; /* 混合版本语法: IE 10 */
    display: -webkit-flex; /* 新版本语法: Chrome 21+ */
    display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  @keyframes myFlash {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes myFlash {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .iv-flash {
    animation: myFlash 1s infinite;
    -webkit-animation: myFlash 1s infinite;
  }

  // .iv-bell-badge {
  //   /deep/ .ivu-badge-count {
  //     border: none;
  //     height: 16px;
  //     line-height: 16px;
  //     top: -5px;
  //     min-width: 16px;
  //     padding: 0;
  //   }
  // }
  .info-scroll {
    position: absolute;
    top: 60px;
    right: -38px;
    z-index: 110;
    min-width: 460px;
  }
}

.ivu-btn-primary {
  background: #2d8cf0 !important;
  border-color: #2d8cf0 !important;
}
</style>
<style lang="scss">
.iv-desktop-li {
  dl {
    overflow: hidden;

    .iconfont {
      font-size: 40px;
    }

    p {
      width: 140px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}

.iv-user-li {
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  &:last-child {
    border: none;
  }
}
</style>
